export default __webpack_public_path__ + "static/media/Tiger's Leggings of Pierced Flesh.20de2ee5.jpg";